// API client pour les actions sur un run individuel.
// Le listing/get est exposé via JobDetailPage (qui agrège runs[] dans la
// réponse getJob). Ce module expose uniquement les actions inverses du
// lifecycle paused : resume(retry|skip) et abort.

import { apiFetch } from "./client";

// retry/skip : reprise d'une pause-sur-échec. continue : reprise d'une pause
// manuelle on-demand (pauseRun).
export type ResumeMode = "retry" | "skip" | "continue";

export interface ResumeRunResponse {
  success: boolean;
  mode: ResumeMode;
  ws_delivered: boolean;
}

export interface PauseRunResponse {
  success: boolean;
  ws_delivered: boolean;
}

export interface AbortRunResponse {
  success: boolean;
  ws_delivered: boolean;
}

// Pause MANUELLE on-demand d'un run en cours. Le device se gare au prochain
// point sûr en conservant son état ; reprise via resumeRun(id, "continue").
export async function pauseRun(runId: string): Promise<PauseRunResponse> {
  return apiFetch<PauseRunResponse>(`/api/runs/${runId}/pause`, {
    method: "POST",
  });
}

// Sort un run de l'état paused. retry = ré-exécute le step qui a fail,
// skip = passe au suivant. Les variables runtime sont conservées côté
// tweak entre la pause et le resume.
export async function resumeRun(
  runId: string,
  mode: ResumeMode
): Promise<ResumeRunResponse> {
  return apiFetch<ResumeRunResponse>(`/api/runs/${runId}/resume`, {
    method: "POST",
    body: JSON.stringify({ mode }),
  });
}

// Abandonne explicitement un run en pause. Bascule en `failed`, envoie
// un abort au tel pour libérer le sémaphore (cleanup standard).
export async function abortRun(
  runId: string,
  reason?: string
): Promise<AbortRunResponse> {
  return apiFetch<AbortRunResponse>(`/api/runs/${runId}/abort`, {
    method: "POST",
    body: JSON.stringify({ reason: reason ?? "manual abort" }),
  });
}
